<div class="container" [style.height]="item.height" [ngStyle.lt-md]="{'height': item.heightMob}" >
    <div id="panorama"></div>
</div>

